<template>
  <div class="finance-btn-group">
    <!-- 财务审核列表-->
    <template v-if="sourceView===sourceViews.manageList">
      <el-button no="CargoView" type="primary" @click="hp._view.showDetailView4Manage(undefined,true)">{{ $t('CargoMsg.Cargo_View') }}</el-button>
      <el-button v-show="$checkPermission(['button_financeModule_batchAudit'])" no="BatchCheckChange" type="primary" @click="hp.batchAuditClickHandler()">{{ $t('CargoMsg.Cargo_BatchAudit') }}</el-button>
      <el-button v-show="$checkPermission(['button_financeModule_checkChange']) && hp.isCommittedAllowAddCost" no="LockTheBill" type="primary" @click="hp.batchCheckChangeClickHandler()">{{ $t('FinanceManage.finance_batchCheckChange') }}</el-button>
      <el-button v-show="$checkPermission(['button_ACPayAuth_lockJob'])" no="BatchCancelAudit" type="success" @click="hp.lockJobsClickHandler()">{{ $t('CargoMsg.Cargo_LockTheBill') }}</el-button>
      <el-button v-show="$checkPermission(['button_financeModule_cancelAudit'])" no="BatchCancelAudit" type="primary" @click="toBatchAudit">{{ $t('CargoMsg.Cargo_BatchCancelAudit') }}</el-button>
      <el-button v-show="$checkPermission(['button_ACPayAuth_provisioned'])" no="Accrue" type="primary" @click="hp.provisionedClickHandler()">{{ $t('CargoMsg.Cargo_Accrue') }}</el-button>
      <el-button v-show="$checkPermission(['button_ACPayAuth_awayProvisioned'])" no="CancelAccrue" type="primary" @click="hp.cancelProvisionedClickHandler()">{{ $t('CargoMsg.Cargo_CancelAccrue') }}</el-button>
      <el-button v-show="$checkPermission(['button_financeModule_businessCommission'])" no="BusinessCommission" type="primary" @click="hp._view.showBusinessCommission=true">{{ $t('CargoMsg.Cargo_BusinessCommission') }}</el-button>
      <!-- <el-button no="Print" type="primary" @click="hp.printClickHandler()">{{ $t('CargoMsg.Cargo_Print') }}</el-button> -->
      <el-dropdown
        no="Print"
        split-button
        type="primary"
        style="margin: 0 5px;"
        @click="hp.printClickHandler($t('CargoMsg.Cargo_Print'))"
        @command="p => hp.printClickHandler(p)"
      >
        {{ $t('CargoMsg.Cargo_Print') }}
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :command="$t('queryJob.PrintByBusinessNumber')">{{ $t('queryJob.PrintByBusinessNumber') }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button v-show="!($checkPermission(['role_hideAllExports']) && !$store.getters.isAdmin)" no="ExportExcelAll" type="primary" @click="hp.exportExcelAllClickHandler()">{{ $t('CargoMsg.Cargo_exportExcelAll') }}</el-button>
      <el-button v-show="$checkPermission(['button_financeModule_updateBusinessDate'])" no="UpdateBusinessDate" type="primary" @click="hp.updateBusinessDateClickHandler()">{{ $t('CargoMsg.Cargo_UpdateBusinessDate') }}</el-button>
      <el-button v-show="$checkPermission(['button_financeModule_batchUpdateExchangeRate'])" no="BatchUpdateExchangeRate" type="primary" @click="hp.batchUpdateExchangeRate()">{{ $t('CargoMsg.Cargo_BatchUpdateExchangeRate') }}</el-button>
      <el-button no="Statistics" type="primary" @click="toStatistics()">{{ $t('SeaExport.Statistics') }}</el-button>
      <el-button v-show="$checkPermission(['button_financeModule_pigeonhole'])" no="pigeonhole" type="primary" @click="hp.pigeonholeHandler()">{{ $t('CargoMsg.Pigeonhole') }}</el-button>
      <el-button v-show="$checkPermission(['button_financeModule_unarchive'])" no="unarchive" type="primary" @click="hp.unarchiveHandler()">{{ $t('CargoMsg.Unarchive') }}</el-button>
    </template>
    <!-- 业务提成-->
    <template v-else-if="sourceView===sourceViews.businessCommission">
      <el-button no="View2" type="primary" @click="hp._view.showDetailView4Business(undefined,true)">{{ $t('CargoMsg.Cargo_View') }}</el-button>
      <el-button v-show="$checkPermission(['button_ACPayAuth_provisioned'])" no="Accrue2" type="primary" @click="hp.provisionedClickHandler()">{{ $t('CargoMsg.Cargo_Accrue') }}</el-button>
      <el-button v-show="$checkPermission(['button_ACPayAuth_awayProvisioned'])" no="CancelAccrue2" type="primary" @click="hp.cancelProvisionedClickHandler()">{{ $t('CargoMsg.Cargo_CancelAccrue') }}</el-button>
      <el-button no="Back" type="primary" @click="hp._view.backManageList">{{ $t('CargoMsg.Cargo_Back') }}</el-button>
    </template>
    <!-- 详情-->
    <template v-else-if="sourceView===sourceViews.detail">
      <el-button no="ReturnQuery" type="primary" @click="hp._view.toBackList">{{ $t('CargoMsg.Cargo_ReturnQuery') }}</el-button>
      <template v-if="detailFromFinanceManage">
        <!-- 财务审核详情-可操作的 -->
        <el-button v-show="$checkPermission(['button_ACPayAuth_lockJob'])" no="LockTheBill2" type="success" @click="hp.lockJobsClickHandler()">{{ $t('CargoMsg.Cargo_LockTheBill') }}</el-button>
        <!--CARGO-6317 财务审核-基本详情页签去除导出全部控件-->
        <!--<el-button type="danger" @click="hp.exportExcelAllClickHandler()">导出全部</el-button>-->
        <el-button v-show="$checkPermission(['button_financeModule_audit'])" no="Audit" type="primary" :disabled="!enabledCheckBtn || hp._view.isCooperate" @click="hp.auditClickHandler()">{{ $t('CargoMsg.Cargo_Audit') }}</el-button>
        <el-button v-show="$checkPermission(['button_financeModule_cancelAudit'])" no="CancelAudit" type="primary" :disabled="!enabledCancelCheckBtn || hp._view.isCooperate" @click="toAudit">{{ $t('CargoMsg.Cargo_CancelAudit') }}</el-button>
        <el-button v-show="hp.isChargeSubmitDirect && $checkPermission(['button_financeModule_chargeAudit'])" no="ChargesAudit" type="primary" @click="hp.chargeAuditClickHandler()">{{ $t('CargoMsg.Cargo_ChargesAudit') }}</el-button>
        <el-button v-show="hp.isChargeSubmitDirect && $checkPermission(['button_financeModule_cancelChargeAudit'])" no="CancelTheChargesAudit" type="primary" @click="hp.cancelChargesAuditClickHandler()">{{ $t('CargoMsg.Cargo_CancelTheChargesAudit') }}</el-button>
        <el-button v-show="hp.openSapConfig || hp.openHecConfig" no="ChargeCommit" type="primary" :disabled="!$checkPermission(['button_financeModule_sapSubmit'])" @click="hp.btnChargeCommitButtonClick()">{{ $t('FinanceManage.finance_ChargeCommit') }}</el-button>
        <el-button v-show="$checkPermission(['button_financeModule_allowChange']) && hp.isCommittedAllowAddCost" no="AllowChange" :disabled="!enabledCancelChargeCheckBtn" type="primary" @click="hp.allowChangeClickHandler()">{{ $t('FinanceManage.finance_allowChange') }}</el-button>
        <el-button v-show="$checkPermission(['button_financeModule_checkChange']) && hp.isCommittedAllowAddCost" no="CheckChange" :disabled="!enabledChargeCheckBtn" type="primary" @click="hp.checkChangeClickHandler()">{{ $t('FinanceManage.finance_checkChange') }}</el-button>
        <el-button no="Print2" type="primary" :disabled="enabledPrintBtn" @click="hp.printHandler()">{{ $t('CargoMsg.Cargo_Print') }}</el-button>
        <el-button no="PrintTheProfit" type="primary" @click="hp.profitPrintClickHandler()">{{ $t('CargoMsg.Cargo_PrintTheProfit') }}</el-button>

        <el-button v-show="$checkPermission(['button_financeModule_accountingDate'])" no="EditFinancialDate" type="primary" :disabled="hp._view.isCooperate || isWkPushInterface" @click="hp.updateAccountingDateClickHandler()">{{ $t('CargoMsg.Cargo_EditFinancialDate') }}</el-button>
        <el-button v-show="$checkPermission(['button_financeModule_accountingDate'])" no="EditChargeFinancialDate" type="primary" :disabled="hp._view.isCooperate || isWkPushInterface" @click="hp.updateChargeAccountingDateClickHandler()">{{ $t('CargoMsg.Cargo_EditChargeFinancialDate') }}</el-button>
        <el-button v-show="$checkPermission(['button_financeModule_businessAdjustment'])" no="BusinessAdjustment" type="primary" :disabled="hp._view.isCooperate || isWkPushInterface" @click="hp.buissInfoClickHandler()">{{ $t('CargoMsg.Cargo_BusinessAdjustment') }}</el-button>
        <el-button v-show="$checkPermission(['button_financeModule_updateExchangeRate'])" no="UpdateExchangeRate" type="primary" :disabled="isWkPushInterface" @click="hp.updateExchangeRate()">{{ $t('CargoMsg.Cargo_UpdateExchangeRate') }}</el-button>
      </template>
      <el-button v-show="enabledAccrualBtn" no="Accrue3" type="primary" :disabled="!enabledAccrualBtn" @click="hp.provisionedClickHandler()">{{ $t('CargoMsg.Cargo_Accrue') }}</el-button>
      <el-button v-show="enabledCancelAccrualBtn" no="CancelAccrue3" type="primary" :disabled="!enabledCancelAccrualBtn" @click="hp.cancelProvisionedClickHandler()">{{ $t('CargoMsg.Cargo_CancelAccrue') }}</el-button>
      <template v-if="detailFromFinanceManage">
        <!-- 财务审核详情-可操作的 -->
        <el-dropdown split-button type="primary" style="margin-left: 5px" @click="handelLogCommand()" @command="p=>{this.logCommand=p;handelLogCommand()}">{{ $t('CargoMsg.Cargo_LogRecord') }}<el-dropdown-menu slot="dropdown">
          <el-dropdown-item no="BusinessAdjustmentLog" command="businessAdjustLogDialog">{{ $t('CargoMsg.Cargo_BusinessAdjustmentLog') }}</el-dropdown-item>
          <el-dropdown-item no="BusinessStatusChangeLog" command="businessStatusLogDialog">{{ $t('CargoMsg.Cargo_BusinessStatusChangeLog') }}</el-dropdown-item>
          <el-dropdown-item no="dataPushResultRecordsDialog" command="dataPushResultRecordsDialog">{{ $t('CargoMsg.Cargo_DataPushResultRecords') }}</el-dropdown-item>
        </el-dropdown-menu>
        </el-dropdown>
      </template>
    </template>

    <!--批量审核-->
    <check-dialog v-if="showCheckDialog" ref="checkDialog" :page-date="adjustPageDate" :show-page-date="true" :visible.sync="showCheckDialog" :edit-approval-date="editApprovalDate" :is-editable="checkDialog.isEditable" :po-no="checkDialog.isEditable ? '' : checkDialog.poNo" @confirm="hp.batchAuditConfirmCB($event)" @returnDatePage="hp.cancelAdjustDate($event)" />
    <!--批量改单,改单审核-->
    <change-bill-dialog v-if="showChangeDialog" ref="changeDialog" :visible.sync="showChangeDialog" @confirm="hp.batchCheckChangeConfirmCB($event)" />
    <!--按业务日期审核--锁单-->
    <lock-order-dialog v-if="showLockOrderDialog" ref="lockOrderDialog" :visible.sync="showLockOrderDialog" :default-job-nos="lockOrderDefaultJobNos" @confirm="hp.lockOrderConfirmCB($event)" />
    <!--计提-->
    <provisioned-dialog v-if="showProvisionedDialog" ref="provisionedDialog" :info="{title:$t('CargoMsg.Cargo_Accrue'),label:$t('CargoMsg.RequiredAccrueDate')}" :disabled-after-today="false" :visible.sync="showProvisionedDialog" @confirm="hp.provisionedConfirmCB($event)" />
    <!--取消计提-->
    <cancel-provisioned-dialog v-if="showCancelProvisionedDialog" ref="cancelProvisionedDialog" :info="{title:$t('CargoMsg.Cargo_CancelAccrue'),label:$t('CargoMsg.RequiredCancelDate')}" :visible.sync="showCancelProvisionedDialog" @confirm="hp.cancelProvisionedConfirmCB($event)" />
    <!--业务日期调整-->
    <business-date-dialog v-if="showBusinessDateDialog" ref="businessDateDialog" :info="{title:$t('CargoMsg.Cargo_UpdateBusinessDate'),label:$t('CargoMsg.Cargo_BusinessDate')}" :disabled-after-today="false" :visible.sync="showBusinessDateDialog" @confirm="hp.updateBusinessDateConfirmCB($event)" />

    <!--    业务调整-->
    <business-adjust-dialog v-if="showBusinessAdjustDialog" :visible.sync="showBusinessAdjustDialog" :job="job" @confirm="hp.buissInfoClickHandlerConfirmCB($event)" />
    <!--业务调整日志-->
    <business-adjust-log-dialog :visible.sync="showBusinessAdjustLogDialog" :job="job" />
    <!--业务状态变更日期 -->
    <business-status-log-dialog v-if="showBusinessStatusLogDialog" :visible.sync="showBusinessStatusLogDialog" :job-uuid="job.uuid||''" />
    <!--数据推送结果记录 -->
    <data-push-result-records-dialog v-if="showDataPushResultRecordsDialog" :visible.sync="showDataPushResultRecordsDialog" :job-uuid="job.uuid||''" />
    <!-- 费用审核-->
    <charge-check-dialog v-if="showChargeCheckDialog" :visible.sync="showChargeCheckDialog" :info="{ title: $t('CargoMsg.Cargo_EditFinancialDate'), label: $t('CargoMsg.Cargo_FinancialDate') }" @confirm="hp.chargeAuditConfirmCB($event)" />
    <!-- 修改财务日期-->
    <update-accounting-date-dialog v-if="showUpdateAccountingDateDialog" :page-date="accountingPageDate" :show-page-date="true" :info="{ title: $t('CargoMsg.Cargo_EditFinancialDate'), label: $t('CargoMsg.Cargo_FinancialDate') }" :visible.sync="showUpdateAccountingDateDialog" @returnDatePage="hp.cancelAccountingDate($event)" @confirm="hp.updateAccountingDateConfirmCB($event)" />
    <!-- 修改费用财务日期-->
    <update-charge-accounting-date-dialog v-if="showUpdateChargeAccountingDateDialog" :info="{ title: $t('CargoMsg.Cargo_EditChargeFinancialDate'), label: $t('CargoMsg.Cargo_FinancialDate') }" :visible.sync="showUpdateChargeAccountingDateDialog" @confirm="hp.updateChargeAccountingDateConfirmCB($event)" />
    <!-- 财务审核 审核弹框-->
    <checking-window
      v-if="checkingWindow.visible"
      :visible.sync="checkingWindow.visible"
      :lob="job.lob"
      :job="job"
      :check-node="checkingWindow.checkNode"
      :call-back="checkingWindow.callBack"
      :call-back2="checkingWindow.callBack2"
      @returnCallBack="returnCallBack"
    />
    <pigeonhole-dialog
      v-if="pigeonholeDialog.visible"
      :visible.sync="pigeonholeDialog.visible"
      :data="pigeonholeDialog.data"
      @confirm="hp.pigeonhole()"
    />
    <!-- 财务审核 批量审核弹框 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      ref="batchCheckingWindow"
      :visible.sync="batchCheckingWindow.visible"
      :allow-partial-check-pass="batchCheckingWindow.allowPartialCheckPass"
      :lob="'all'"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
      @returnCallBack="batchReturnCallBack"
    />
    <!-- 统计弹窗 -->
    <el-dialog
      v-if="statisticsDialog.visible"
      v-el-drag-dialog
      :visible.sync="statisticsDialog.visible"
      :title="$t('SeaExport.Statistics')"
      :width="$selectByLang('360px', '445px')"
      :close-on-click-modal="false"
    >
      <el-form :label-width="$selectByLang('85px', '170px', '170px', '200px', '220px', '220px')" label-position="left">
        <el-form-item :label="$t('SeaExport.Slaves')" class="custom">
          <el-input v-model="statisticsDialog.txtSlaves" no="txtSlaves" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Master')" class="custom">
          <el-input v-model="statisticsDialog.txtMaster" no="txtMaster" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.TotalTickets')" class="custom">
          <el-input v-model="statisticsDialog.txtCount" no="txtCount" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.CustomerCount')" class="custom">
          <el-input v-model="statisticsDialog.txtCustomerCount" no="txtCustomerCount" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.NominatedAgentCount')" class="custom">
          <el-input v-model="statisticsDialog.txtDesignationAgentNum" no="txtDesignationAgentNum" style="width:160px" :disabled="true" />
        </el-form-item>
        <el-form-item label-width="0" class="custom">
          <el-checkbox v-model="statisticsDialog.containShutOutJob" no="containShutOutJob" @change="toStatistics">{{ $t('SeaExport.ContainShutOutJob') }}</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button no="Close" @click="statisticsDialog.visible = false">{{ $t('SeaExport.Close') }}</el-button>
      </div>
    </el-dialog>

    <!-- 审核弹窗 -->
    <el-dialog v-el-drag-dialog class="partner-audit-dialog" :visible.sync="auditDialog.visible" :title="$t('CargoMsg.Cargo_CancelAudit')" style="font-weight: bold;" width="420px" :close-on-click-modal="false" @close="cancelAudit">
      <div style="display: flex; align-items: center; justify-content: center;">
        <i class="el-icon-warning" style="color: #E6A23C; font-size: 20px;" />
        <span>{{ $t('CargoMsg.Cargo_AuditCancel') }}</span>
      </div>
      <el-form label-width="75px" label-position="right">
        <el-form-item required :label="$t('CargoMsg.Cargo_Cancel') + $t('CargoMsg.Cargo_Reason')">
          <el-input v-model="auditDialog.rejectReason" no="rejectReason" type="textarea" :rows="9" style="width: 310px" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button no="ok" type="primary" @click="handleOk">{{ $t('common.btn.ok') }}</el-button>
        <el-button no="cancel" @click="cancelAudit">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import FinanceManageHP from './financeManageHp'
// import FinanceDetailHp from './financeDetailHp'
// import BusinessCommissionHP from './businessCommissionHP'
import AbstractFinanceManage from './AbstractFinanceManage'

import checkDialog from './checkDialog'
import chargeCheckDialog from './changeDialog'
import changeBillDialog from './changeDialog'
import provisionedDialog from './changeDialog'
import cancelProvisionedDialog from './changeDialog'
import updateAccountingDateDialog from './changeDialog'
import updateChargeAccountingDateDialog from './changeDialog'
import businessDateDialog from './changeDialog'
import lockOrderDialog from './lockOrderDialog'
import businessAdjustDialog from './businessAdjustDialog'
import businessAdjustLogDialog from './businessAdjustLogDialog'
import businessStatusLogDialog from './businessStatusLogDialog'
import checkingWindow from '@/components/Cargo/Job/CheckingManager/CheckingWindow'
import batchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'

import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getGridSelected } from '@/utils/agGrid'
import DataPushResultRecordsDialog
  from '@/views/cargo/v0/Clearing/components/financeManage/dataPushResultRecordsDialog'
import PigeonholeDialog from '@/components/Cargo/Job/pigeonholeDialog.vue'
import ElIcon from 'element-ui/packages/icon/src/icon.vue'
import { cache, cacheName } from '@/utils/cacheManager'
// import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'

const manageList = 'manageList' // 财务审核
const businessCommission = 'businessCommission'// 业务提成
const detail = 'detail' // 详情
export default {
  name: 'FinanceBtnGroup',
  components: {
    ElIcon,
    PigeonholeDialog,
    DataPushResultRecordsDialog, checkDialog, chargeCheckDialog, updateAccountingDateDialog, updateChargeAccountingDateDialog, cancelProvisionedDialog, changeBillDialog, provisionedDialog, businessDateDialog, lockOrderDialog,
    businessAdjustDialog,
    businessAdjustLogDialog,
    businessStatusLogDialog, checkingWindow, batchCheckingWindow },
  props: {
    sourceView: { type: String, default: 'manageList', validator: (value) => { return [manageList, businessCommission, detail].includes(value) } }, //
    job: { type: Object },
    gridOptions: { type: Object },
    hp: { type: Object, required: true, validator: (value) => value instanceof AbstractFinanceManage },
    activeTabName: { type: String, required: false, default: 'basic' }
  },
  data() {
    return {
      showBusinessAdjustDialog: false,
      showBusinessAdjustLogDialog: false,
      showUpdateAccountingDateDialog: false,
      showUpdateChargeAccountingDateDialog: false,

      showBusinessStatusLogDialog: false,
      showDataPushResultRecordsDialog: false,
      showChargeCheckDialog: false,
      accountingPageDate: new Date(), // 修改财务日期 记录用户上次选择的时间
      adjustPageDate: new Date(), // 审核 记录用户上次选择的时间
      showCheckDialog: false,
      lockOrderDefaultJobNos: '',
      editApprovalDate: false,
      batchShowCheckDialog: false,
      checkDialog: {
        isEditable: false,
        poNo: ''
      },
      showChangeDialog: false,
      showLockOrderDialog: false,
      showProvisionedDialog: false,
      showCancelProvisionedDialog: false,
      showBusinessDateDialog: false,
      showAccrualDialog: false,
      showCancelAccrualDialog: false,
      sourceViews: {
        manageList,
        detail,
        businessCommission
      },
      checkingWindow: {
        visible: false,
        checkNode: 13,
        callBack: null,
        callBack2: null
      },
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        allowPartialCheckPass: false,
        checkNode: 13,
        callBack: null,
        callBack2: null
      },
      pigeonholeDialog: {
        visible: false,
        data: null
      },
      auditDialog: {
        visible: false,
        auditType: '',
        rejectReason: ''
      },
      jobReviewCancelMustFillReason: false, // 取消业务审核需要填写原因。0=无需填写，1=需填写
      isWk: false,
      logCommand: 'businessAdjustLogDialog',
      enabledPrintBtn: false, // 控制打印按钮是否可用
      statisticsDialog: {
        visible: false,
        txtSlaves: 0,
        txtMaster: 0,
        txtCount: 0,
        txtCustomerCount: 0,
        txtDesignationAgentNum: 0,
        containShutOutJob: false
      }
    }
  },
  computed: {
    detailFromFinanceManage() { // 来源于财务审核主列表
      return this.hp._view.viewSource === 'manageList'
    },
    enabledChargeCheckBtn() {
      // 改单审核：业务状态：已审核；改单状态：改单提交
      return this.job && this.job.jobState === SystemConstants.STATE_VERIFIED.code && this.job.changeState === SystemConstants.CHANGE_COMMIT.code
    },
    enabledCancelChargeCheckBtn() {
      // 允许改单：业务状态：已审核；改单状态：不可改单、改单审核
      return (this.job && this.job.jobState === SystemConstants.STATE_VERIFIED.code && (this.job.changeState === SystemConstants.CHANGE_CANNOTCHANGE.code || this.job.changeState === SystemConstants.CHANGE_AUDIT.code))
    },
    enabledAccrualBtn() {
      return this.job && (!this.job.provisioned) && this.$checkPermission(['button_ACPayAuth_provisioned'])
    },
    enabledCancelAccrualBtn() {
      return this.job && this.job.provisioned && this.$checkPermission(['button_ACPayAuth_awayProvisioned'])
    },
    enabledCheckBtn() {
      return this.job && this.job.jobState === 1
    },
    enabledCancelCheckBtn() {
      if (this.job && this.job.jobState === 2) {
        if (this.hp.isCommittedAllowAddCost) {
          if (this.job.changeState === SystemConstants.CHANGE_CANNOTCHANGE.code || this.job.changeState === SystemConstants.CHANGE_AUDIT.code) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      } else {
        return false
      }
    },
    isWkPushInterface() {
      return this.isWk && this.job && this.job.pushStatus > 0
    }
  },
  watch: {
    // 父类已处理过了
    // async job(newVal) {
    //   if (newVal) {
    //     await cache.load(cacheName.CONFIG)
    //     this.hp.isCommittedAllowAddCost = parseInt(cache.config.get('IsCommittedAllowAddCost')) === 1
    //     this.hp.openSapConfig = parseInt(cache.config.get('openSapConfig')) === 1
    //   }
    // },
    activeTabName(newVal) {
      if (newVal) {
        this.enabledPrintBtn = newVal === 'tabVesselEq' || newVal === 'tabCharges' || newVal === 'tabAdvanceCharge'
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.jobReviewCancelMustFillReason = Number(cache.config.get('jobReviewCancelMustFillReason')) === 1
    this.isWk = cache.config.get('ToExoSystem') === 'WK'
  },
  beforeMount() {
    // 将该控件进行注入
    this.hp.financeBtnGroupView = this
    this.hp.checkingWindow = this
    this.hp.batchCheckingWindow = this
  },
  methods: {
    getLockOrderDefaultJobNos() {
      const rows = this.gridOptions ? (getGridSelected(this.gridOptions) || []) : []
      const jobNos = rows.map(item => item && item.jobNo).filter(Boolean)
      if (jobNos.length > 0) {
        return [...new Set(jobNos)].join(',')
      }
      return this.job && this.job.jobNo ? this.job.jobNo : ''
    },
    handelLogCommand() {
      if (this.logCommand === 'businessAdjustLogDialog') {
        this.showBusinessAdjustLogDialog = true
      }
      if (this.logCommand === 'businessStatusLogDialog') {
        this.showBusinessStatusLogDialog = true
      }
      if (this.logCommand === 'dataPushResultRecordsDialog') {
        this.showDataPushResultRecordsDialog = true
      }
    },
    returnCallBack(showCheckDialog) {
      this.checkDialog.poNo = this.job.poNo
      this.checkDialog.isEditable = false
      this.showCheckDialog = showCheckDialog
    },
    batchReturnCallBack(batchShowCheckDialog) {
      this.checkDialog.isEditable = batchShowCheckDialog
      this.showCheckDialog = batchShowCheckDialog
    },
    // 统计
    toStatistics() {
      if (!this.statisticsDialog.visible) {
        this.statisticsClean()
      }
      const rows = this.getStatisticsRows()
      const designationAgents = []
      const customers = []
      let slavesCount = 0
      let masterCount = 0
      let count = 0
      for (const job of rows) {
        // 不包含退关业务统计
        if (job.shutOut && !this.statisticsDialog.containShutOutJob) {
          continue
        }
        count++
        if (job.masterFlag) {
          masterCount += 1
        } else {
          slavesCount += 1
        }
        if (!customers.includes(job.customerId) && !job.masterFlag) {
          customers.push(job.customerId)
        }
        if (!designationAgents.includes(job.designationAgent) && job.designationAgent !== 0) {
          designationAgents.push(job.designationAgent)
        }
      }
      this.statisticsDialog.txtSlaves = slavesCount.toString()
      this.statisticsDialog.txtMaster = masterCount.toString()
      this.statisticsDialog.txtCount = count.toString()
      this.statisticsDialog.txtCustomerCount = customers.length.toString()
      this.statisticsDialog.txtDesignationAgentNum = designationAgents.length.toString()
      this.statisticsDialog.visible = true
    },
    // 统计完成
    statisticsClean() {
      if (!this.statisticsDialog) return
      this.statisticsDialog = PriceUtils.resetFilter(this.statisticsDialog)
    },
    getStatisticsRows() {
      const rows = getGridSelected(this.gridOptions)
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      return rows
    },
    refresh() {
      this.hp.refresh()
    },
    toBatchAudit() {
      if (this.jobReviewCancelMustFillReason) {
        this.auditDialog.auditType = 'list'
        this.hp.checkBatchCancelAuditClickHandler(this.auditDialog)
        return
      }
      this.hp.batchCancelAuditClickHandler()
    },
    batchPassAudit() {
      this.hp.batchCancelAuditClickRejectReasonHandler(this.auditDialog.rejectReason)
      this.auditDialog.visible = false
      this.auditDialog.auditType = ''
      this.auditDialog.rejectReason = ''
    },
    toAudit() {
      if (this.jobReviewCancelMustFillReason) {
        this.auditDialog.auditType = 'detail'
        this.hp.checkCancelAuditClickHandler(this.auditDialog)
        return
      }
      this.hp.cancelAuditClickHandler()
    },
    detailPassAudit() {
      this.hp.cancelAuditClickRejectReasonHandler(this.auditDialog.rejectReason)
      this.auditDialog.visible = false
      this.auditDialog.auditType = ''
      this.auditDialog.rejectReason = ''
    },
    handleOk() {
      if (!this.auditDialog.rejectReason) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_Reason'))
        return
      }
      if (this.auditDialog.auditType === 'list') {
        this.batchPassAudit()
      } else if (this.auditDialog.auditType === 'detail') {
        this.detailPassAudit()
      }
    },
    cancelAudit() {
      this.auditDialog.visible = false
      this.auditDialog.rejectReason = ''
    }
  }
}
</script>

<style scoped lang="scss">
  .finance-btn-group{
  }
</style>
